var leica = leica || {};
leica.pi = leica.pi || {};
leica.pi.esm = leica.pi.esm || {};

leica.pi.esm.columnNavigator = (function() {
	"use strict";
	var cn = {};
	
	// Cache the $(window) reference for use during scroll events. 
	var $window = $( window );
		
	// update column navitaion column scrolling (< or >) and column content. buildColumnHtml
	function build($table) {
		// Update column indicator & scroll buttons
		var visibleColumns = getVisibleColumns($table);
		if (visibleColumns) {
			var last = ((visibleColumns.lastIndex+1) > visibleColumns.totalCount)
						? visibleColumns.totalCount : (visibleColumns.lastIndex+1);
			
			$table.find('.columns-visible').text(visibleColumns.startIndex+1 + '-' + last);
			$table.find('.column-count').text(visibleColumns.totalCount);
			$table.find('.column-scroll').removeClass('Disabled');
			if (visibleColumns.startIndex == 0) {
				$table.find('.column-scroll:first').addClass('Disabled');
			}
			if (last >= visibleColumns.totalCount) {
				$table.find('.column-scroll:last').addClass('Disabled');
			}
			 
		}
	}
	//scrollToColumns
	function scroll($table, direction) {
		var	visibleColumns = getVisibleColumns($table);
		if (visibleColumns)	{

			var $tableHeader = $table.find('thead tr:not(.tableFloatingHeader):first');
			var $listTableDivWrapper = getDivToMove($table, 'down');
			var visibleWidth = $listTableDivWrapper.width();
			var	leftPos = 0;
			var $next;

			if (direction == 'previous') {
				
				$next = $tableHeader.find('th:eq(' + (visibleColumns.startIndex+1) + ')');
				if ($next.length > 0){
					leftPos = $next.position().left - visibleWidth;
				}
			} 
			else {
				
				var tableWidth = $tableHeader.width();
				$next = $tableHeader.find('th:eq(' + (visibleColumns.lastIndex+1) + ')');
				if ($next.length > 0){
					leftPos = $next.position().left - $table.find('td.fixed-column:first').width();
					if (leftPos > (tableWidth - visibleWidth))
						leftPos = tableWidth - visibleWidth;
				}
			}
			

			// Scroll contents of list table
			$listTableDivWrapper.scrollLeft(leftPos);
			
			cn.syncHeader($table);
			
		}

		build($table);
	}
	
	// column to visible on left and right click for column navigation 
	// @return e.g. visibleColumns = Object {count: 0, totalCount: 16, startIndex: 0, lastIndex: 8}
	function getVisibleColumns($table) {
		var $tableHeader = $table.find('thead tr:not(.tableFloatingHeader):first');
		var visibleColumns = { count: 0, totalCount: 0, startIndex: -1, lastIndex: -1 };
		var FixedWidth = $table.find('td.fixed-column:first').width();
		//when fixed column <td> is not present for tables that do not have any data then
		//look for fixed column <th> and for tables that do not have <th> with fixed column, make fixedwidth zero
		if (!FixedWidth) {
			var thWidth = $table.find('th.fixed-column:first').width();
			FixedWidth = (thWidth) ? thWidth : 0;
		}
		$tableHeader.find('th:not(.fixed-column)').each(function(index, obj) {
			var _bounds = obj.getBoundingClientRect();
			if (_bounds.right <= $window.width() &&  _bounds.left >= FixedWidth) {
				if (visibleColumns.startIndex == -1) {
					visibleColumns.startIndex = index;
				}
				visibleColumns.lastIndex = index;
			}
			visibleColumns.totalCount++;
		});
		return visibleColumns;
	}
	
	/**
 	 * Walk each cell in $table's floating header and shift it to the left by the same offset of $wrapper.
 	 * NOTE: For this strategy to work, the floating header's width must always match $table's visible scrollable area,
 	 *       with its CSS overflow property set to 'hidden'. This will assure that the individual header cells will
 	 *       always be hidden when they're positioned outside the left and right margins of the table.
 	 * @param $table - the table containing the floating header
 	 * @param $wrapper - the wrapper that's used to shift the position of the table rows
 	 * Make sure the fixed columns are also in sync
 	 */
	cn.syncHeader = function($table){
		var $listTableDivWrapper = getDivToMove($table, 'down');
		var firstListTableDivWrapper = $listTableDivWrapper.get(0);
		
		var $tableFloatingHeader = $table.find('.tableFloatingHeader_clone');
 		var offsetLeft = firstListTableDivWrapper.scrollLeft;
 		
 		//Shift each cell in $table's floating header to the left by the same offset of $wrapper
 		$tableFloatingHeader.find('th:not(.fixed-column)').css({
 			position: 'relative',
 			left: -offsetLeft,
 			top: 0
 		});
		
 		// Ensure fixed column remains fixed
		$table.find('thead th.fixed-column > div:not(.tableFloatingHeader th > div), tbody td.fixed-column, .summary-row td').css('left', offsetLeft);
	}
	
	cn.columnScrolling = function($table){
		var $body = $('body');
		
		if(typeof $table === 'undefined' || !$table.length){
			return;
		}
		// Column navigation section
		build($table);
		
		// Unbind the previous attached click event
		$table.find('.column-scroll').off('.columnScroll').on('click.columnScroll', function(event) {
			event.preventDefault();
			scroll($table, $(this).data('direction'));
		});
		
		$window.on('load scroll resize', window.piDash.throttle(function (event){
			build($table);	
			cn.syncHeader($table);			
		}));
		
		
		 $(document).on('RenameAdvanceSearchResults', function(event){
			  build($table);
	     });
		
		 // Area for tab changed e.g. specimen tab open
	      $body.on('tabChanged', function(event, data){ 
	    	  build($table);    	        
	      });
		
	}
	
	return cn;
})();


